import axios from "../services/axios";

import { toast } from "react-toastify";

const loginAPI = (basicAuth) => {
  return axios.post(
    "sessions",
    {},
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Content-Type": "application/json",
        withCredentials: true,
        mode: "no-cors",
        Authorization: basicAuth,
      },
    }
  );
};

const logoutAPI = (token) => {
  return axios.delete(
    "sessions/" + token,
    {},
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

const changePassAPI = (userId, token, data) => {
  return axios.patch("layouts/CustomerChangePassword/records/" + userId, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

const getInfoUser = (data, token) => {
  return axios.post("layouts/CustomerUser - Get Info/_find", data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

const updateCompanyAPI = (userKey, token) => {
  return axios.get(
    "layouts/TraCuuKH - API/script/UpdateCompanyList?script.param=" + userKey,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  );
};

const getData = (
  inputDate,
  inputCompany,
  inputCont,
  inputStatus,
  limit,
  offset,
  token,
  inputWarehouse = "",
  signal
) => {
  try {
    // Chuyển đổi ngày từ "MM/DD/YYYY..MM/DD/YYYY" sang "YYYYMMDD..YYYYMMDD"
    const convertDate = (dateStr) => {
      if (!dateStr || dateStr === "*") return null;
      const parts = dateStr.split("..");
      const convertPart = (part) => {
        const [month, day, year] = part.split("/");
        return `${year}${month.padStart(2, "0")}${day.padStart(2, "0")}`;
      };
      if (parts.length === 2) {
        return `${convertPart(parts[0])}..${convertPart(parts[1])}`;
      }
      return convertPart(parts[0]);
    };

    const formattedDate = convertDate(inputDate);

    // Kiểm tra giá trị có hợp lệ không (khác rỗng và khác "*")
    const isValidValue = (value) => value && value !== "" && value !== "*";

    // Xây dựng query object
    const buildQueryObject = (contField) => {
      const obj = {};
      if (formattedDate) {
        obj.LOG_SORT_DATE = formattedDate;
      }
      if (isValidValue(inputCont)) {
        obj[contField] = inputCont;
      }
      if (isValidValue(inputCompany)) {
        obj.CONG_TY = inputCompany;
      }
      if (isValidValue(inputStatus)) {
        obj.StatusValue = inputStatus;
      }
      if (isValidValue(inputWarehouse)) {
        obj.NOI_DONG_HANG = `==${inputWarehouse}`;
      }
      return obj;
    };

    // Nếu chỉ có LOG_SORT_DATE, chỉ cần 1 query object
    const hasOtherFields = isValidValue(inputCont) || isValidValue(inputCompany) || isValidValue(inputStatus) || isValidValue(inputWarehouse);

    let queryArray;
    if (!hasOtherFields && formattedDate) {
      queryArray = [{ LOG_SORT_DATE: formattedDate }];
    } else {
      const queryObj1 = buildQueryObject("SO_CONT");
      const queryObj2 = buildQueryObject("SO_BOOKING");
      queryArray = [queryObj1, queryObj2];
    }

    const query = JSON.stringify({
      query: queryArray,
      sort: [
        {
          fieldName: "LOG_SORT_DATE",
          sortOrder: "descend",
        },
      ],
      // "script.prerequest": "UpdateDateRange",
      // "script.prerequest.param": inputDate,
      limit: limit,
      offset: offset,
    });
    return axios.post("layouts/TraCuuKH - API/_find", query, {
      signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      maxBodyLength: Infinity,
    });
  } catch (e) {
    console.log(e);
    toast.error("Phiên truy cập hết hạn, vui lòng đăng nhập lại!.");
  }
};

const getWarehouseEmptySlots = async (company, token, signal, selectedWarehouse = "") => {
  const hasCompany = company && company !== "*";
  if (!selectedWarehouse) return null;
  const query = { KEO_XONG_MANG_TRONG: "*" };
  if (hasCompany) query.CONG_TY = `==${company}`;
  query.NOI_DONG_HANG = `==${selectedWarehouse}`;
  let result;
  try {
    result = await axios.post("layouts/BookingLine/_find", {
      query: [query],
      sort: [{ fieldName: "ModificationTimestamp", sortOrder: "descend" }],
      limit: 1,
      offset: 1,
    }, {
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      signal,
    });
  } catch (error) {
    if (error.response?.data?.messages?.[0]?.code === "401") return null;
    throw error;
  }
  const payload = result?.data;
  if (payload?.messages?.[0]?.code === "401") return null;
  if (payload?.messages?.[0]?.code !== "0") throw new Error("Không tải được số máng trống");
  const raw = payload.response?.data?.[0]?.fieldData?.KEO_XONG_MANG_TRONG;
  if (raw === null || raw === undefined || String(raw).trim() === "") return null;
  const value = Number(raw);
  if (!Number.isInteger(value)) throw new Error("Số máng trống không hợp lệ");
  return value;
};

// Read every page so the warehouse list is not limited to the visible table page.
const getWarehouseOptions = async (inputDate, inputCompany, token, signal) => {
  const warehouses = new Set();
  let offset = 1;
  while (true) {
    let result;
    try {
      result = await getData(inputDate, inputCompany, "*", "*", 500, offset, token, "", signal);
    } catch (error) {
      if (error.response?.data?.messages?.[0]?.code === "401") break;
      throw error;
    }
    const payload = result?.data;
    if (payload?.messages?.[0]?.code === "401") break;
    if (payload?.messages?.[0]?.code !== "0") {
      throw new Error("Không tải được danh sách kho");
    }
    const rows = payload.response?.data || [];
    rows.forEach(({ fieldData }) => {
      const name = fieldData?.NOI_DONG_HANG;
      if (typeof name === "string" && name.trim()) warehouses.add(name);
    });
    offset += rows.length;
    if (!rows.length || offset > Number(payload.response?.dataInfo?.foundCount)) break;
    if (!Number.isFinite(Number(payload.response?.dataInfo?.foundCount))) {
      throw new Error("Không xác định được tổng số bản ghi kho");
    }
  }
  return [...warehouses].sort((a, b) => a.localeCompare(b, "vi"))
    .map(name => ({ label: name, value: name }));
};

const getCompanyFound = (token, date) => {

  const convertDate = (dateStr) => {
    if (!dateStr || dateStr === "*") return null;
    const parts = dateStr.split("..");
    const convertPart = (part) => {
      const [month, day, year] = part.split("/");
      return `${year}${month.padStart(2, "0")}${day.padStart(2, "0")}`;
    };
    if (parts.length === 2) {
      return `${convertPart(parts[0])}..${convertPart(parts[1])}`;
    }
    return convertPart(parts[0]);
  };

  const formattedDate = convertDate(date);

  const data = {
    "query": [
      {
        "LOG_SORT_DATE": formattedDate
      }
    ],
    "limit": "500",
    "offset": "1"
  }

  return axios.post("layouts/CompanyFound_BookingLine/_find", data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    maxBodyLength: Infinity,
  });
};

const getFile = (recordId, token) => {
  return axios.get("layouts/TraCuuKH - File/records/" + recordId, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    maxBodyLength: Infinity,
  });
};

const getDaoCont = (SO_CONT, token) => {

  const data = {
    "query": [
      {
        // {{SO_CONT}}
        "SO_CONT": SO_CONT
      }
    ],
    "limit": "1",
    "offset": "1"
  }

  return axios.post("/layouts/TraCuuKH - DaoCont/_find", data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    maxBodyLength: Infinity,
  });

}



const getSiteShip = async () => {
  try {
    return await axios.get("/layouts/SiteShip/records", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      maxBodyLength: Infinity,
    });
  } catch (e) {
    console.log(e);
    toast.error("Phiên truy cập hết hạn, vui lòng đăng nhập lại!.");
  }
};

const getSaiGonNewPort = async (siteId, vesselName) => {
  const optionSiteShip = localStorage.getItem("optionSiteShip");
  const parseOption = JSON.parse(optionSiteShip);
  const filter = await parseOption.data.filter(
    (value) =>
      value.fieldData.SiteID === siteId || value.fieldData.NoiHa === siteId
  );
  let setSiteID = "GNL";
  if (filter.length > 0) {
    setSiteID = filter[0].fieldData.SiteID;
  }
  const param = JSON.stringify({
    siteId: setSiteID,
    vesselName: vesselName,
  });

  return axios.get(
    `/layouts/SiteShip/script/ePortShipsSearch?script.param=${param}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      maxBodyLength: Infinity,
    }
  );
};


const getDataExpense = (
  inputDate,
  inputCompany,
  inputCont,
  limit,
  offset,
  token
) => {
  try {
    // Chuyển đổi ngày từ "MM/DD/YYYY..MM/DD/YYYY" sang "YYYYMMDD..YYYYMMDD"
    const convertDate = (dateStr) => {
      if (!dateStr || dateStr === "*") return null;
      const parts = dateStr.split("..");
      const convertPart = (part) => {
        const [month, day, year] = part.split("/");
        return `${year}${month.padStart(2, "0")}${day.padStart(2, "0")}`;
      };
      if (parts.length === 2) {
        return `${convertPart(parts[0])}..${convertPart(parts[1])}`;
      }
      return convertPart(parts[0]);
    };

    const formattedDate = convertDate(inputDate);

    // Kiểm tra giá trị có hợp lệ không (khác rỗng và khác "*")
    const isValidValue = (value) => value && value !== "" && value !== "*";

    // Xây dựng query object
    const buildQueryObject = (contField) => {
      const obj = {};
      if (formattedDate) {
        obj.LOG_SORT_DATE = formattedDate;
      }
      if (isValidValue(inputCont)) {
        obj[contField] = inputCont;
      }
      if (isValidValue(inputCompany)) {
        obj.CONG_TY = inputCompany;
      }
      return obj;
    };

    // Nếu chỉ có LOG_SORT_DATE, chỉ cần 1 query object
    const hasOtherFields = isValidValue(inputCont) || isValidValue(inputCompany);

    let queryArray;
    if (!hasOtherFields && formattedDate) {
      queryArray = [{ LOG_SORT_DATE: formattedDate }];
    } else {
      const queryObj1 = buildQueryObject("SO_CONT");
      const queryObj2 = buildQueryObject("SO_BOOKING");
      queryArray = [queryObj1, queryObj2];
    }

    const query = JSON.stringify({
      query: queryArray,
      sort: [
        {
          fieldName: "LOG_SORT_DATE",
          sortOrder: "ascend",
        },
      ],
      // "script.prerequest": "UpdateDateRange",
      // "script.prerequest.param": inputDate,
      limit: limit,
      offset: offset,
    });
    return axios.post("layouts/CustomerExpense - API/_find", query, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      maxBodyLength: Infinity,
    });
  } catch (e) {
    console.log(e);
    toast.error("Phiên truy cập hết hạn, vui lòng đăng nhập lại!.");
  }
};

const getInvoiceLinkAPI = (data, token) => {

  try {
    const query = {
      "query": [
        {
          //Hóa đơn nâng thì lấy nơi lấy cont, hóa đơn hạ thì lấy nơi hạ
          "LocationName": `==${data}`
        }
      ]
    }
    return axios.post("layouts/InvoiceLink - API/_find", query, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      maxBodyLength: Infinity,
    });
  } catch (e) {
    console.log(e);
    toast.error("Phiên truy cập hết hạn, vui lòng đăng nhập lại!.");
  }

}


const inputPONumberAPI = (data, id, token) => {

  console.log("data", data);
  console.log("id", id);
  console.log("token", token);
  try {
    const query = {
      "fieldData": {
        "CUS_SO_PO": data
      }
    }
    return axios.patch(`layouts/TraCuuKH - API/records/${id}`, query, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      maxBodyLength: Infinity,
    });
  } catch (e) {
    console.log(e);
    toast.error("Phiên truy cập hết hạn, vui lòng đăng nhập lại!.");
  }

}

const inputInvoiceNumberAPI = (data, id, token) => {
  try {
    const query = {
      "fieldData": {
        "CUS_SO_Invoice": data
      }
    }
    return axios.patch(`layouts/TraCuuKH - API/records/${id}`, query, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      maxBodyLength: Infinity,
    });
  } catch (e) {
    console.log(e);
    toast.error("Phiên truy cập hết hạn, vui lòng đăng nhập lại!.");
  }

}


export {
  loginAPI,
  getInvoiceLinkAPI,
  getDataExpense,
  inputPONumberAPI,
  inputInvoiceNumberAPI,
  logoutAPI,
  changePassAPI,
  updateCompanyAPI,
  getInfoUser,
  getData,
  getWarehouseOptions,
  getWarehouseEmptySlots,
  getCompanyFound,
  getFile,
  getSiteShip,
  getSaiGonNewPort,
  getDaoCont
};
